import { useAuthContext } from "@stonelog/stonelog-auth-components";

// Roles do usuário logado (campo user.roles do login), ex.: ["perfil_liga", "perfil_angel"]
export const useRoles = () => {
  const auth = useAuthContext();
  return auth?.getUser()?.roles || [];
};
